import * as React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "css/brm-react-tabs.css";
import PropTypes from "prop-types";
import DynamicSubTabSelector from "components/elements/DynamicSubTabSelector";
import { DetailsTableMap } from "brm/tables/details/DetailsTableMap";
import { DetailTableType } from "features/brm";
import { useRoles } from "features/brm/hooks/useRoles";

const accessMenu = [DetailTableType.ACCESS_POINTS, DetailTableType.ATTACK_SURFACES, DetailTableType.ENTRY_POINTS];

const attacksMenu = [DetailTableType.ATTACKERS];

const systemMenu = [DetailTableType.NODES, DetailTableType.EXCHANGES, DetailTableType.ACTIVITIES];

const AttackVectorDetails = ({ selectedElement }) => {
  const elementNameInUrl = DetailTableType.ATTACK_VECTORS.key;

  const { isRiskAnalyst } = useRoles();
  const [selectedContext, setSelectedContext] = React.useState(DetailTableType.NODES.key);
  const [selectedAccessContext, setSelectedAccessContext] = React.useState("entryPoints");
  const [selectedAttackContext, setSelectedAttackContext] = React.useState("attackers");
  const [curr, setCurr] = React.useState("");

  return (
    <Tabs id="AttackVectorDetails_Tab">
      <TabList id="AttackVectorDetails_TabList">
        <Tab onClick={() => setCurr(DetailTableType.SYSTEM.name)}>
          <DynamicSubTabSelector
            title={DetailTableType.SYSTEM.name}
            menu={systemMenu}
            setSelectedContext={setSelectedContext}
            curr={curr}
          />
        </Tab>

        <Tab onClick={() => setCurr(DetailTableType.ACCESS.name)}>
          <DynamicSubTabSelector
            title={DetailTableType.ACCESS.name}
            menu={accessMenu}
            setSelectedContext={setSelectedAccessContext}
            curr={curr}
          />
        </Tab>

        {isRiskAnalyst && (
          <>
            <Tab onClick={() => setCurr(DetailTableType.ATTACK.name)}>
              <DynamicSubTabSelector
                title={DetailTableType.ATTACK.name}
                menu={attacksMenu}
                setSelectedContext={setSelectedAttackContext}
                curr={curr}
              />
            </Tab>
          </>
        )}
      </TabList>

      <TabPanel>
        <DetailsTableMap
          elementNameInUrl={elementNameInUrl}
          selectedElement={selectedElement}
          selectedContext={selectedContext}
        />
      </TabPanel>

      <TabPanel>
        <DetailsTableMap
          elementNameInUrl={elementNameInUrl}
          selectedElement={selectedElement}
          selectedContext={selectedAccessContext}
        />
      </TabPanel>

      <TabPanel>
        <DetailsTableMap
          elementNameInUrl={elementNameInUrl}
          selectedElement={selectedElement}
          selectedContext={selectedAttackContext}
        />
      </TabPanel>
    </Tabs>
  );
};

AttackVectorDetails.propTypes = {
  selectedElement: PropTypes.object.isRequired,
};

export default AttackVectorDetails;
